/**
 * Address helper class (included by the helper service)
 *
 */
export class AddressHelper {
    public readonly europeanCountries: Array<string> = [
        'AT',
        'BE',
        'BG',
        'CY',
        'CZ',
        'DE',
        'DK',
        'EE',
        'EL',
        'ES',
        'FI',
        'FR',
        'HR',
        'HU',
        'IE',
        'IT',
        'LT',
        'LU',
        'LV',
        'MT',
        'NL',
        'PL',
        'PT',
        'RO',
        'SE',
        'SI',
        'SK',
    ];

    /**
     * Check whether the given country alpha2 is an european country
     *
     * @param countryAlpha2
     * @return boolean
     */
    public isEuropeanCountry(countryAlpha2: string): boolean {
        return this.europeanCountries.includes(countryAlpha2);
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/helpers/address.helper.ts